
webpack.register(
    'components/scroll-top/scroll-top',
    function() {
        return import('components/scroll-top/scroll-top');
    },
    true
);

webpack.register(
    'components/scroll-top/scroll-top',
    function() {
        return import('components/scroll-top/scroll-top');
    },
    true
);